module.exports = __webpack_public_path__ + "static/media/hourglass.d2527aa0.png";